import React, { useState, useEffect, useRef } from 'react'
import { Tag, Button, Form, DatePicker, message } from 'antd'
import moment from 'moment'
import useHandle from '@/hooks/handle'
import CommonTable from '@/components/commonTable'
import {
  _getBikeExercise,
  _getBikeExercisePage,
  _getBikeExerciseExport,
} from '../../../../../statics/js/api.js'
import './style.less'

const { RangePicker } = DatePicker
const Index = (props) => {
  const { filter, form } = props
  let { imei, bikeId } = filter
  const [motionStatus, setMotionStatus] = useState({})
  const tableRef = useRef()
  const { getFieldDecorator } = form
  const [firstSelectedDate, setFirstSelectedDate] = useState(null)
  const { loading: exportLoading, handleDownload } = useHandle()

  // 获取并格式化日期范围
  const getDateRange = () => {
    const values = form.getFieldsValue()
    if (!values.date || values.date.length !== 2) {
      message.warning('请选择日期范围')
      return null
    }

    const [startTime, endTime] = values.date
    return {
      startTime: moment(startTime).format('YYYY-MM-DD'),
      endTime: moment(endTime).format('YYYY-MM-DD'),
    }
  }

  const columns = [
    {
      title: '日期',
      dataIndex: 'dateStr',
    },
    {
      title: '开始时间',
      dataIndex: 'startTimeStr',
    },
    {
      title: '结束时间',
      dataIndex: 'endTimeStr',
    },
    {
      title: '状态',
      dataIndex: 'exerciseStatus',
      render: (text) => (
        <Tag color={text === 1 ? 'green' : 'red'}>{text === 1 ? '运动' : '静止'}</Tag>
      ),
    },
    {
      title: '时长',
      dataIndex: 'duration',
    },
  ]

  // 搜索处理
  const handleSearch = (e) => {
    e && e.preventDefault()
    form.validateFields((err) => {
      if (err) {
        return
      }

      const dateRange = getDateRange()
      if (!dateRange) return

      handleMotionStatus()
      tableRef.current.handleSearch({
        bikeId,
        ...dateRange,
      })
    })
  }

  // 车辆运动数据汇总
  const handleMotionStatus = () => {
    const dateRange = getDateRange()
    if (!dateRange) return

    _getBikeExercise({
      bikeId,
      ...dateRange,
    })
      .then((res) => {
        setMotionStatus(res.data.data || {})
      })
      .catch((err) => {
        console.error('获取运动数据汇总出错:', err)
      })
  }

  // 导出
  const handleExport = () => {
    if (exportLoading) return

    const dateRange = getDateRange()
    if (!dateRange) return

    handleDownload({
      action: _getBikeExerciseExport,
      query: {
        bikeId,
        ...dateRange,
      },
    })
  }

  useEffect(() => {
    handleSearch()
  }, [])

  // 日期选择变化时的处理函数
  const handleCalendarChange = (dates) => {
    if (dates && dates.length === 1) {
      setFirstSelectedDate(dates[0])
    } else if (!dates || dates.length === 0) {
      setFirstSelectedDate(null)
    }
  }

  // 日期输入框值变化的处理函数
  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setFirstSelectedDate(null)
    }
  }

  // 判断日期是否可选
  const disabledDate = (current) => {
    if (!firstSelectedDate || !current) {
      return false
    }

    try {
      const diff = Math.abs(current.diff(firstSelectedDate, 'days'))
      return diff > 180
    } catch (error) {
      console.error('日期计算出错:', error)
      return false
    }
  }

  // 添加日期选择器打开关闭的处理函数
  const handleOpenChange = (open) => {
    if (open) {
      setFirstSelectedDate(null)
    }
  }

  return (
    <div className='motion_status_wrap'>
      <Form onSubmit={handleSearch} layout='inline'>
        <Form.Item className='motion_status_form_item'>
          {getFieldDecorator('date', {
            initialValue: [moment().subtract(30, 'days'), moment()],
            rules: [{ required: true, message: '请选择日期范围' }],
            valuePropName: 'defaultValue',
          })(
            <RangePicker
              format='YYYY-MM-DD'
              renderExtraFooter={() => <div>日期范围不能超过180天</div>}
              onCalendarChange={handleCalendarChange}
              onChange={handleDateChange}
              onOpenChange={handleOpenChange}
              disabledDate={disabledDate}
            />
          )}
        </Form.Item>
        <Form.Item className='motion_status_form_item'>
          <Button icon='search' type='primary' htmlType='submit' style={{ marginRight: 16 }}>
            搜索
          </Button>
          <Button icon='download' onClick={handleExport} loading={exportLoading}>
            导出
          </Button>
        </Form.Item>
      </Form>

      <div className='motion_status_header'>
        <div className='motion_status_header_item'>
          <div className='motion_status_header_item_title'>设备编号</div>
          <div className='motion_status_header_item_code'>{motionStatus.deviceId}</div>
        </div>
        <div className='motion_status_header_item'>
          <div className='motion_status_header_item_title'>运动总时长</div>
          <div className='motion_status_header_item_run'>{motionStatus.moveDuration}</div>
        </div>
        <div className='motion_status_header_item'>
          <div className='motion_status_header_item_title'>静止总时长</div>
          <div className='motion_status_header_item_stop'>{motionStatus.stopDuration}</div>
        </div>
      </div>

      <CommonTable
        ref={tableRef}
        auto={false}
        action={_getBikeExercisePage}
        options={{
          columns: columns,
        }}
      />
    </div>
  )
}

const MotionStatus = Form.create()(Index)
export default MotionStatus
